import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Parser from 'html-react-parser';

import ErrorBoundary from '../../ErrorBoundary';

const DuplicatePreviewItemCustomField = ({ customField, customFields }) => {
  if (!customField || !customField.value) {
    return null;
  }

  const field = customFields.find(cf => (cf.id === customField.id));
  if (!field) {
    return null;
  }

  return (
    <ErrorBoundary>
      <li className="duplicated-preview-detail">
        <h5>{field.name}:</h5>
        <div className="duplicated-preview-detail-content">
          <p>{Parser(customField.value)}</p>
        </div>
      </li>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  customFields: state.Metadata.customFields,
});

DuplicatePreviewItemCustomField.propTypes = {
  customFields: PropTypes.array.isRequired,
  customField: PropTypes.object,
};

DuplicatePreviewItemCustomField.defaultProps = {
  customField: null,
};

export default connect(mapStateToProps)(DuplicatePreviewItemCustomField);
